import {runWebviewToAppBridge} from '~/common/utils/webview';

// Pass a string (modal identifier) as message
export function webViewModalShowing(message: string) {
  runWebviewToAppBridge('modalIsShowing', message);
}
